import { DOCUMENT_STATUS_CONFIG } from './statusMapping';
import { TopStatusBarRoot } from './styles';
import type { DocumentStatus } from './types';

/** 상단 컬러 바 — 문서 상태 tone 색 반영 (PHP 조회 화면 최상단 라인). */
type TopStatusBarProps = {
  status?: DocumentStatus;
};

const TopStatusBar = ({ status }: TopStatusBarProps) => {
  const tone = status
    ? DOCUMENT_STATUS_CONFIG[status]?.tone ?? 'neutral'
    : 'neutral';
  return <TopStatusBarRoot tone={tone} aria-label="document status bar" />;
};

export default TopStatusBar;
